import { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { getManagerPanel } from '../../services/migration/personnelDataService';

export interface ManagerWarehousePermissions {
  canView: boolean;
  canAdjust: boolean;
  canViewMovements: boolean;
  loaded: boolean;
}

const NONE: ManagerWarehousePermissions = { canView: false, canAdjust: false, canViewMovements: false, loaded: false };

/** Depo modülü açıkken warehouse_view kaydı yoksa görüntüleme açık sayılır. */
export const resolveWarehousePermissions = (settings: any): Omit<ManagerWarehousePermissions, 'loaded'> => {
  const s = settings || {};
  const subs = s['warehouse_subPermissions'] || {};
  const canView = s['warehouse'] === true && subs['warehouse_view'] !== false;
  return {
    canView,
    canAdjust: canView && subs['warehouse_adjust'] === true,
    canViewMovements: canView && subs['warehouse_movements'] === true,
  };
};

/**
 * Şube yöneticisinin Depo yetkileri (managerPanel SettingsJson). Kural backend'deki
 * ManagerPanelPermissions.IsGranted ile aynıdır. `enabled` false ise istek atılmaz.
 */
export const useManagerWarehousePermissions = (enabled: boolean): ManagerWarehousePermissions => {
  const { currentUser } = useAuth();
  const [perms, setPerms] = useState<ManagerWarehousePermissions>(NONE);

  useEffect(() => {
    if (!enabled || !currentUser?.uid) {
      setPerms(NONE);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const mp = await getManagerPanel(currentUser.uid);
        if (cancelled) return;
        setPerms({ ...resolveWarehousePermissions(mp.found ? mp.settings : null), loaded: true });
      } catch (e) {
        console.warn('[useManagerWarehousePermissions] managerPanel okunamadı:', e);
        if (!cancelled) setPerms({ ...NONE, loaded: true });
      }
    })();
    return () => { cancelled = true; };
  }, [enabled, currentUser?.uid]);

  return perms;
};
